import React from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import logo from '../../assets/images/logo.png';

const Advt = React.memo(() => {
  const { qrCode1, qrCode2 } = useGetParams();

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />

      <div className={styles.qrsWrapper}>
        <div className={styles.title}>Присылайте варианты ответов</div>

        <div className={styles.qrBlock}>
          {qrCode1 && (
            <div className={styles.qrCode}>
              <img src={qrCode1} alt="qrCode1" />
            </div>
          )}
          {qrCode2 && (
            <div className={styles.qrCode}>
              <img src={qrCode2} alt="qrCode1" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default Advt;
